var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "var(--native-icon-fill)",
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#telegram_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.493 9.856-.231 3.257c.331 0 .475-.142.647-.313l1.553-1.485 3.219 2.357c.59.33 1.006.156 1.165-.543l2.113-9.9c.188-.873-.315-1.215-.89-1L1.65 6.983c-.847.33-.834.802-.143 1.016l3.175.987 7.375-4.614c.347-.23.663-.103.403.127L6.493 9.856Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "telegram_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(1 1)",
    d: "M0 0h14v14H0z"
  })))));
};

export default SvgTelegram;